import React from 'react';
import GreenTick from '../assets/green-tick.png';
import * as S from './OtpVerified.styles';

const OtpVerified = ({
  heading,
  headingIcon,
  subHeading,
  inportantInfo,
  message,
  timer,
  panVerified,
  responseRedirectUrl,
  tncClause,
  height,
  setModalCaller,
  isVerificationSuccessFull = true,
  isOpenDifferentModalFlag = false,
  setModalType,
  marginTop,
  showLinkButton = false,
  closeModal = false,
  handleCloseModal,
  isRedirectToPage = false,
  isClosable = false,
}) => {
  const handleRedirection = () => {
    if (closeModal) {
      handleCloseModal && handleCloseModal();
    }
    if (isOpenDifferentModalFlag) {
      setModalType && setModalType();
    } else if (responseRedirectUrl) {
      window.open(responseRedirectUrl, '_self');
    } else {
      window.location.reload();
    }
  };

  return (
    <S.Container panVerified={panVerified} height={height}>
      {isClosable && (
        <S.PopHeaderMainWrap onClick={handleRedirection}>
          <S.PopHeaderBackWrap alignRight={false}>
            <S.PopHeaderBackText>Close</S.PopHeaderBackText>
          </S.PopHeaderBackWrap>
        </S.PopHeaderMainWrap>
      )}
      {heading && (
        <S.Heading>
          {headingIcon && (
            <div className="iconDiv">
              <S.Icon>
                {!isVerificationSuccessFull ? (
                  <span className="aiSprite aisYellowExclaimation"></span>
                ) : (
                  <img src={GreenTick} alt="" />
                )}
              </S.Icon>
            </div>
          )}
          {heading}
        </S.Heading>
      )}
      {inportantInfo && (
        <S.ImpInfo>
          <p dangerouslySetInnerHTML={{__html: inportantInfo}} />
        </S.ImpInfo>
      )}
      {subHeading && <S.SubHeading>{subHeading}</S.SubHeading>}
      {!showLinkButton ? (
        message && (
          <S.Info subHeading={subHeading} onClick={handleRedirection} marginTop={marginTop}>
            {<S.InfoText>{message}</S.InfoText>}
          </S.Info>
        )
      ) : (
        <S.LinkButton onClick={handleRedirection} className="aisAddBtn">
          {message}
        </S.LinkButton>
      )}
      {tncClause && <S.ClauseText>{tncClause}</S.ClauseText>}
    </S.Container>
  );
};

export default OtpVerified;
